// extracted by mini-css-extract-plugin
var _1 = "AITextGeneration-moduleform__JO_Zm AITextGeneration-moduleAITextGeneration__e0XwN";
export { _1 as "form" }
